import { Component, ElementRef, ViewChild } from '@angular/core';
import { DownloadStudyModalComponent } from './download-study-modal/download-study-modal.component';
import { StudyHistoricModalComponent } from './study-historic-modal/study-historic-modal.component';
import { ReportViewerComponent } from './report-viewer/report-viewer.component';
import { HttpEventType } from '@angular/common/http';
import { StudiesService } from '../../services/studies.service';
import { AlertService } from '../../services/alert.service';
import { BookService } from '../../services/book.service';
import { ConfigService } from '../../services/config.service';
import { AuthService } from '../../services/auth.service';
import { User } from '../../data/user';
import { Filters, StudyFilters } from '../../data/filters';
import { PageSimplifiedStudy, SimplifiedStudy } from '../../data/study';
import { fillTable } from '../../utils/fillTable';


const studyCreator = () => { return { id: null } }


@Component({
  selector: 'app-book-list',
  templateUrl: './book-list.component.html',
  styleUrls: ['./book-list.component.css']
})
export class BookListComponent {

  @ViewChild('StudySearchTerm') _studySearchTerm!: ElementRef;
  @ViewChild('PatientSearchTerm') _patientSearchTerm!: ElementRef;
  @ViewChild(DownloadStudyModalComponent) downloadStudyModalComponent!: DownloadStudyModalComponent;
  @ViewChild(StudyHistoricModalComponent) studyHistoricModalComponent!: StudyHistoricModalComponent;
  @ViewChild(ReportViewerComponent) reportViewerComponent!: ReportViewerComponent;


  get isStudyListEmpty(): boolean {
    if (this.studyList?.length == null || this.studyList.length <= 0 || this.studyList.every(b => b.id == null)) {
      this.studyList = [];
      return true;
    }
    return false;
  }

  get studySearchTerm(): string {
    return (this._studySearchTerm?.nativeElement?.value != null && this._studySearchTerm.nativeElement.value.trim() != '') ? this._studySearchTerm.nativeElement.value : '';
  }

  get patientSearchTerm(): string {
    return (this._patientSearchTerm?.nativeElement?.value != null && this._patientSearchTerm.nativeElement.value.trim() != '') ? this._patientSearchTerm.nativeElement.value : '';
  }

  user: User | null = null;


  constructor(
    private studyService: StudiesService,
    private authService: AuthService,
    private alertService: AlertService,
    private bookService: BookService,
    private configService: ConfigService,
  ) { 
    this.authService.asyncUser.then(user => {
      this.user = user;
    })
  } 

  tablesStyles = {
    books: {
      paddingLeft: '1em',
      paddingRight: '1em',
      width: '100%',
      transition: '1s'
    }
  }

  studyFilters: StudyFilters = Filters.getNewStudyFilters();
  studyList: SimplifiedStudy[] = [];

  displayedColumns: String[] = ['PatientName', 'StudyDate', 'StudyDescription', 'Actions']

  pageStudies = 1;
  pageSize = (window.innerHeight >= 800) ? 10 : 8;

  totalStudies = 1;

  refreshing = false;
  lastRefresh = 0;
  refreshInterval: any = null;

  downloading: { studyUID: string | null, percentage: number } | null = null; //variable para descargar el estudio + imágenes


  ngOnInit(): void {

    this.refreshData();
    
    this.refreshInterval = setInterval(() => {
      if (this.lastRefresh + 1000 < new Date().getTime()) {
        this.refreshData();
      }
    }, 2000);

  }

  refreshData() {
    // Renovar token de sesión al refrescar datos
    //this.authService.renewUserSessionToken();
    
    if (!this.refreshing) {
      this.refreshing = true;
      Promise.all([this.refreshStudies()]).then(res => {
        this.lastRefresh = new Date().getTime();
        this.refreshing = false;
      }).catch(error => this.refreshing = false);
    }
  }

  refreshStudies(): Promise<void | SimplifiedStudy[]> {
    return this.getStudies().then(studies => {
      this.totalStudies = studies.totalElements;
      if (studies.content.length > 0) {
        const auxStudy = SimplifiedStudy.sanitizeAll(studies.content);
        this.studyList = fillTable(auxStudy, this.pageSize, studyCreator);
      } else {
        this.studyList = [];
      }
    }
    ).catch(error => {
      console.error('Error fetching studies:', error);
    });
  }

  getStudies(): Promise<PageSimplifiedStudy> {

    this.studyFilters.pageConfig.pageNumber = this.pageStudies - 1;
    this.studyFilters.pageConfig.pageSize = this.pageSize;
    this.studyFilters.pageConfig.sort1 = 'studyDateTimestamp';
    this.studyFilters.pageConfig.direction1 = 'desc';
    this.studyFilters.studyDescription = this._studySearchTerm?.nativeElement.value.trim() || null;
    this.studyFilters.patientName = this._patientSearchTerm?.nativeElement.value.trim() || null;    

    return new Promise((resolve, reject) => {
      if(this.user != null){
        // Se refiere al id de User pero el UserId del Prescriber del Generador de Books
        this.studyService.getPageStudiesByUserId(this.user.id, this.studyFilters).then(books => {
          console.log('BOOKS, in get book ', books);
          resolve(books);
        })
      }else{
        reject('No user logged in');
      }
    })
    
  }

  onPageChange(evt: any) {
    // Renovar token de sesión al navegar
    //this.authService.renewUserSessionToken();
    //this.refreshData();
  }

  async onClickOpenVisor(study: SimplifiedStudy) {
    // Renovar token de sesión
    //this.authService.renewUserSessionToken();
    
    if (study.studyUID == null || study.studyUID == '') {
      this.alertService.alert('No se ha encontrado el estudio. Por favor, póngase en contacto con el centro hospitalario');
      return;
    }

    try {
      //if (await this.studyService.checkIfStudyHasFiles(study.studyUID)) {
        this.openVisor(study.studyUID);
      //} else {
        //this.getStudyFromQuery(study);
      //}
    } catch (error) {
      console.error('Error intentado abrir estudio:', error);
      this.alertService.alert('Ha habido un error al intentar abrir el estudio. Por favor, inténtelo de nuevo más tarde.');
    }
  }

  // Primero obtenemos el token de acceso y luego abrimos el visor
  openVisor(studyUID: string) {
    try {
      this.bookService.getTokenByStudyUID(studyUID).then(tkn => {
        try{

          this.configService.getConfig().then(c => {
            const route = c.visorRoute + `?sid=${studyUID}&ustkn=${tkn}`;
            window.open(route, 'Visor', 'toolbar=no,top=10,left=10,width=' + (screen.width - 50) + ',height=' + (screen.height - 100));
          })
        }catch(error){
          console.error('Error obteniendo la ruta del visor en la configuración:', error);
        }
      });
    } catch (error) {
      console.error('Error intentado obtener el token de acceso del estudio con UID: '+studyUID, error);
    }
  }

  getStudyFromQuery(study: SimplifiedStudy) {
    if (!study.studyUID) {
      console.error('No studyUID provided');
      return;
    }

    this.studyService.obtainStudy(study.studyUID).then(() => {
      this.alertService.alert('Se ha solicitado el estudio. Podrá visualizarlo en unos momentos cuando se termine la solicitud.');
    }).catch(error => {
      console.error('Error al solicitar el estudio:', error);
      // El error ya se maneja en el servicio con un alert
    });
  }

  onClickDownloadStudy(study: SimplifiedStudy) {
    // Renovar token de sesión
    //this.authService.renewUserSessionToken();
    
    if(study.studyUID == null){
      this.alertService.alert('Error al descargar el estudio. Por favor, inténtelo de nuevo más tarde.');
      console.error("StudyUIDs is null");
      return;
    }

    if (this.downloading == null) {
      this.downloading = { studyUID: study.studyUID, percentage: 0 }
      setTimeout(() => {
        
        let startedDownloading = false;
        const randomIntFromInterval = (min: number, max: number) => { // min and max included 
          return Math.floor(Math.random() * (max - min + 1) + min)
        }
        const interval = setInterval(() => {
          if (startedDownloading) {
            clearInterval(interval);
          } else {
            if (this.downloading!.percentage < 10) {
              this.downloading!.percentage += (randomIntFromInterval(0, 30) / 100) // ~ 1m 15s
            } else if (this.downloading!.percentage < 20) {
              this.downloading!.percentage += (randomIntFromInterval(10, 30) / 100) // ~ 1m
            } else if (this.downloading!.percentage < 30) {
              this.downloading!.percentage += (randomIntFromInterval(10, 50) / 100) // ~ 35s
            } else if (this.downloading!.percentage < 35) {
              this.downloading!.percentage += (randomIntFromInterval(0, 10) / 100) // ~ 1m 50s
            } else if (this.downloading!.percentage < 50) {
              this.downloading!.percentage += (randomIntFromInterval(0, 7) / 100) // ~ 8m
            }
          }
        }, 1200);
        this.studyService.downloadStudies([study.studyUID!]).subscribe(event => {
          if (event!.type == HttpEventType.DownloadProgress) {
            startedDownloading = true;
            const percentage = ((event!.loaded / event!.total!) * 50) + 50
            this.downloading!.percentage = Math.round(percentage)
          }
          if (event!.type == HttpEventType.Response) {
            const link = document.createElement('a');
            if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              const url = URL.createObjectURL(event!.body!);
              link.setAttribute('href', url);
              link.setAttribute('download', "dicomdir.zip");
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
            this.downloading = null;
          }
        }, error => {
          console.error('Error downloading study:', error);
          this.alertService.alert('Error al descargar el estudio. Por favor, inténtelo de nuevo más tarde.');
          this.downloading = null;
        });
      }, 1);
    } else {
      this.alertService.alert('Ya se está descargando un estudio. Por favor, espere a que finalice')
    }
  }

  onClickDownloadReport(study: SimplifiedStudy) {
    // Renovar token de sesión
    //this.authService.renewUserSessionToken();
    
    if(study.studyUID != null){
      this.studyService.downloadReport([study.studyUID]);
    }else{
      console.error("StudyUIDs is null");
      // alert.service
    }
  }

  onClickStudiesQuery(study: SimplifiedStudy) {
    if(study.studyUID != null && study.studyUID != ""){
      this.studyHistoricModalComponent?.open(study.studyUID, study.patientName ?? '');
    } else {
      console.error('StudyUID is null or empty');
    }
  }

  onClickSeeBook(study: SimplifiedStudy){
    if(study.studyUID != null && study.studyUID != ""){
      this.bookService.checkAccessWithStudyUID(study.studyUID).then(res => {
      
        if (res != null) {
          const protocol = location.protocol + '//'
          const hostname = location.hostname
          const route = `${protocol+hostname}/books/acceso?tkn=${res.token}&acctk=${res.accessionToken}`;
          window.open(route);
          
        } else {
          this.alertService.alert('No se ha podido abrir el book. Por favor, póngase en contacto con su centro');

        }
      }).catch(e => {
        console.error(e);
        this.alertService.alert('Ha habido un error abriendo el book. Por favor, póngase en contacto con su centro');
      })

    }

  }

  onClickOpenReportPreview(study: SimplifiedStudy) {
    // Renovar token de sesión
    //this.authService.renewUserSessionToken();
    
    if(study.studyUID != null && study.studyUID != ""){
      this.reportViewerComponent?.showByStudyUID(study.studyUID);
    } else {
      console.error('StudyUID is null or empty');
      this.alertService.alert('No se puede mostrar el informe. StudyUID no disponible.');
    }
  }

}

